// Maps the contact page's `?ref=` query param to a prefilled subject line.
// A ref listed here also makes the page smooth-scroll to the form and locks
// the subject field. Unknown values are ignored and the page behaves normally.
// Add an entry whenever a marketing page links to /contact?ref=<key>.
export const REF_SUBJECTS: Record<string, string> = {
    "mezzanine": "Steel Solutions Mezzanine",
    "referral-program": "Referral Program",
};

export function subjectForRef(ref: string | null | undefined): string | null {
    if (!ref) return null;
    return Object.prototype.hasOwnProperty.call(REF_SUBJECTS, ref) ? REF_SUBJECTS[ref] : null;
}
